import { render, staticRenderFns } from "./trafficAlertSteps.vue?vue&type=template&id=4787f114&scoped=true"
import script from "./trafficAlertSteps.vue?vue&type=script&lang=js"
export * from "./trafficAlertSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787f114",
  null
  
)

export default component.exports